// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperAbstract-cls1_j0p","cls2":"PaperAbstract-cls2_mui PaperAbstract-cls1_j0p","variant-dense":"PaperAbstract-variant-dense_rk6"};